import { useReducer } from "react";

function countReducer(count) {
  return count + 1;
}

export function useCounter(initialCount = 0) {
  return useReducer(countReducer, initialCount);
}
